import React, { useEffect, useRef } from "react";

const RenderEmailContent = ({ sender_email, recipient_email, html }) => {
    const iframeRef = useRef(null);

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data?.type === 'resize' && iframeRef.current) {
                iframeRef.current.style.height = `${event.data.height + 32}px`;
            }
        };

        window.addEventListener('message', handleMessage);

        if (iframeRef.current) {
            const iframeDoc = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;
            iframeDoc.open();
            iframeDoc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <base target="_blank">
          <style>
            body { margin: 0; padding: 16px; font-family: Arial, sans-serif; line-height: 1.5; color: #1a1a1a; }
            img { max-width: 100%; height: auto; }
            * { max-width: 100%; }
          </style>
        </head>
        <body>
          ${html}
          <script>
            function updateHeight() {
              const height = document.body.scrollHeight;
              window.parent.postMessage({ type: 'resize', height: height }, '*');
            }
            updateHeight();
            new MutationObserver(updateHeight).observe(document.body, { childList: true, subtree: true });
          </script>
        </body>
      </html>
    `);
            iframeDoc.close();
        }

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [html]);

    return <iframe ref={iframeRef} className="w-full border-0 bg-white" title="Email Content" />;
};

export default RenderEmailContent;